import React from "react";

export const Activation = () => {
  return <div>This will be the activation onboarding</div>;
};
